"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const button_1 = __importDefault(require("src/components/button"));
const b = b_1.default.with('page');
const i18n = (0, i18n_1.default)(['page']);
function NextBtn(props) {
    const { label = i18n(['buttonNext']) } = props;
    return ((0, jsx_runtime_1.jsx)(button_1.default, Object.assign({ "data-test": 'next-btn', mix: b('button-next') }, props, { children: label })));
}
exports.default = NextBtn;
